var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5584 4.35829C16.2167 4.22496 14.875 4.12496 13.525 4.04996V4.04163L13.3417 2.95829C13.2167 2.19163 13.0334 1.04163 11.0834 1.04163H8.90005C6.95838 1.04163 6.77505 2.14163 6.64172 2.94996L6.46672 4.01663C5.69172 4.06663 4.91672 4.11663 4.14172 4.19163L2.44172 4.35829C2.09172 4.39163 1.84172 4.69996 1.87505 5.04163C1.90838 5.38329 2.20838 5.63329 2.55838 5.59996L4.25838 5.43329C8.62505 4.99996 13.0251 5.16663 17.4417 5.60829C17.4667 5.60829 17.4834 5.60829 17.5084 5.60829C17.8251 5.60829 18.1 5.36663 18.1334 5.04163C18.1584 4.69996 17.9084 4.39163 17.5584 4.35829Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0254 6.78337C15.8254 6.57504 15.5504 6.45837 15.2671 6.45837H4.73378C4.45044 6.45837 4.16711 6.57504 3.97544 6.78337C3.78378 6.99171 3.67544 7.27504 3.69211 7.56671L4.20878 16.1167C4.30044 17.3834 4.41711 18.9667 7.32544 18.9667H12.6754C15.5838 18.9667 15.7004 17.3917 15.7921 16.1167L16.3088 7.57504C16.3254 7.27504 16.2171 6.99171 16.0254 6.78337ZM11.3838 14.7917H8.60878C8.26711 14.7917 7.98378 14.5084 7.98378 14.1667C7.98378 13.825 8.26711 13.5417 8.60878 13.5417H11.3838C11.7254 13.5417 12.0088 13.825 12.0088 14.1667C12.0088 14.5084 11.7254 14.7917 11.3838 14.7917ZM12.0838 11.4584H7.91711C7.57544 11.4584 7.29211 11.175 7.29211 10.8334C7.29211 10.4917 7.57544 10.2084 7.91711 10.2084H12.0838C12.4254 10.2084 12.7088 10.4917 12.7088 10.8334C12.7088 11.175 12.4254 11.4584 12.0838 11.4584Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.a7eb1af14bb1858b7ba4c816de3811f6.svg";
export { ForwardRef as ReactComponent };